<template>
  <div>
    <a-drawer
      title="添加菜品"
      :width="620"
      @close="onClose"
      :visible="visible"
      :wrapStyle="{maxHeight: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
      <a-spin :spinning="spinning">
        <a-form layout="horizontal" :form="form">
          <a-form-item label="菜品名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <!-- <a-input placeholder="请输入菜品名称"/> -->
            <a-auto-complete
              @select="onSelectMenu"
              @search="onSearchMenu"
              placeholder="请输入菜品名称"
              optionLabelProp="text"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '菜品名称不能为空' }]}
        ]"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="item in menuSource"
                  :key="item.name+'_'+item.id"
                  :text="item.name"
                  :value="item.name+'_'+item.id+'_'+item.imgUrl+'_'+item.describe+'_'+item.isEnable"
                >
                  <a-row>
                    <a-col :span="14">{{item.name}}</a-col>
                    <a-col :span="10" style="text-align:right">此菜品可能已经存在,去编辑</a-col>
                  </a-row>
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-form-item>
          <a-form-item label="菜品图片" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-upload
              name="avatar"
              listType="picture-card"
              class="avatar-uploader"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
              @change="selectImg"
            >
              <img v-if="imageUrl" :src="imageUrl" alt="avatar">
              <div v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">选择图片</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item label="描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-textarea placeholder="请输入菜品描述" :rows="4" v-model="describe"/>
          </a-form-item>
          <a-form-item label="企业是否可见" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-switch
              checkedChildren="可见"
              unCheckedChildren="不可见"
              v-decorator="[
          'isEnable',{ valuePropName: 'checked',initialValue:true }
        ]"
            />
          </a-form-item>
        </a-form>
        <div class="component-table">
          <a-row style="width:100%;background: #fafafa;">
            <a-col :span="8" style="padding: 10px 10px;">成分名称</a-col>
            <a-col :span="8" :offset="2" style="padding: 10px 10px;">重量（单位：g）</a-col>
            <a-col :span="4" :offset="2" style="padding: 10px 10px;"></a-col>
          </a-row>
          <a-row
            style="width:100%;padding: 8px;border-bottom: 1px solid #eee;"
            type="flex"
            justify="center"
            align="middle"
            v-if="componentData.length<=0"
          >
            <a-col :span="24" style="text-align:center">暂无数据</a-col>
          </a-row>
          <a-row
            style="width:100%;padding: 8px;border-bottom: 1px solid #eee;"
            type="flex"
            justify="space-between"
            align="middle"
            v-if="componentData.length>0"
            v-for="(item,index) in componentData"
            :key="index"
          >
            <a-col :span="9">
              <a-select
                style="width: 100%;"
                showSearch
                :allowClear="true"
                v-model="item.name"
                placeholder="请输入食材名称"
                :filterOption="false"
                :notFoundContent="null"
                @search="onComponentSearch"
                @change="onComponentChange"
              >
                <a-select-option
                  v-for="d in componentListBySearch"
                  :key="d.food_Id"
                  :value="d.food_Id"
                >{{d.food_Name}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="9" :offset="2">
              <a-input placeholder="请输入重量" v-model="item.weight" type="number"/>
            </a-col>
            <a-col :span="2" :offset="2" style="text-align: right;">
              <a-popconfirm
                title="你确定删除此成分吗?"
                @confirm="confirmRemove"
                okText="Yes"
                cancelText="No"
                placement="leftTop"
              >
                <a-icon type="close" style="color:red;cursor:pointer" @click="alertRemove(index)"/>
              </a-popconfirm>
            </a-col>
          </a-row>
          <a-button type="dashed" block style="margin-top:10px" @click="addComponent">
            <a-icon type="plus"/>添加菜品组成成分
          </a-button>
        </div>
        <div
          :style="{
          position: 'fixed',
          right: 0,
          bottom: 0,
          width: '620px',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
        >
          <a-button :style="{marginRight: '8px'}" @click="onClose">取消</a-button>
          <a-button @click="onSave" type="primary" :loading="submitLoading">提交</a-button>
        </div>
      </a-spin>
    </a-drawer>
  </div>
</template>
<script>
import { getComponentByName, getMenuByName } from '@/apis/common-dishe'
import { exitSameObj, debounce } from '@/utils/base'
const columns = [
  {
    title: '成分名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '重量(单位：g)',
    dataIndex: 'weight',
    scopedSlots: { customRender: 'weight' }
  },
  {
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
let timer = null
export default {
  data () {
    return {
      dataSource: [],
      menuSource: [],
      previewVisible: false,
      previewImage: '',
      image: null,
      columns,
      componentData: [],
      loading: false,
      imageUrl: '',
      uploadLoading: false,
      menuName: '',
      form: this.$form.createForm(this),
      describe: '',
      componentListBySearch: [] // 模糊搜索出来的食材
      // index: 0 //食材索引，为了给
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    spinning: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },

    // 选择搜索的菜品后,说明录入的菜已经存在了，直接去编辑就行了，跳转到编辑页面
    onSelectMenu (value) {
      this.menuName = value
      console.log(value)
      this.$emit('gotoEdit', value)
    },

    // 搜索菜品,启用防抖
    onSearchMenu (value) {
      this.menuName = value
      if (value) {
        if (timer) {
          clearTimeout(timer)
          timer = null
        }
        timer = setTimeout(() => {
          getMenuByName({ search: this.menuName }).then(res => {
            if (res.data.state === 1) {
              console.log(res)
              this.menuSource = res.data.attribute
            }
          })
        }, 500)
      } else {
        this.menuSource = []
      }
    },

    selectImg (info) {},

    // 上传前
    beforeUpload (file) {
      this.file = file
      getBase64(file, imageUrl => {
        this.imageUrl = imageUrl
        this.loading = false
      })
      return false
    },

    // 添加成分
    addComponent () {
      let item = {
        id: '',
        name: '',
        weight: ''
      }
      this.componentData.push(item)
    },

    // 搜索食物成分
    onComponentSearch (value) {
      if (value) {
        if (timer) {
          clearTimeout(timer)
          timer = null
        }

        timer = setTimeout(() => {
          getComponentByName({ search: value }).then(res => {
            if (res.data.state === 1) {
              this.componentListBySearch = res.data.attribute
            }
          })
        }, 500)
      }
    },

    // 选择食物成分
    onComponentChange (value, option) {
      console.log(value, option)
    },

    // 移除
    alertRemove (index) {
      this.currentIndex = index
    },

    // 确认移除
    confirmRemove () {
      this.componentData = this.componentData.filter((item, index) => {
        return index != this.currentIndex
      })
    },

    // 提交
    onSave () {
      let that = this
      if (!this.componentData.length) {
        this.$message.warning('菜品组成成分不能为空')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          debugger
          let componentData = []

          for (let i = 0; i < that.componentData.length; i++) {
            const item = that.componentData[i]
            if (!item.name || !item.weight) {
              that.$message.warning('菜品组成成分不能存在空的数据')
              return
            }
            componentData.push({
              id: item.name,
              weight: Number(item.weight)
            })
          }

          let isExitSame = exitSameObj(componentData, 'id')
          if (isExitSame) {
            that.$message.warning('存在相同的组成成分，请检查后重新提交')
            return
          }

          let formData = {
            name: that.menuName,
            describe: that.describe,
            list: componentData,
            isEnable: values.isEnable
          }
          that.$emit('submit', JSON.stringify(formData), that.file)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ant-table-body {
  line-height: 0.5;
  tr td {
    padding: 10px 10px;
  }
}

.ant-drawer-body {
  max-height: calc(100% - 108px);
  overflow-y: scroll;
  .ant-form-item {
    margin-bottom: 14px;
  }
}

.ant-upload-btn {
  img {
    height: 250px;
  }
}

.component-table {
  display: flex;
  flex-direction: column;
  align-items: center;
  .component-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .component-body {
    width: 100%;
    display: flex;
    flex-direction: columns;
    .body-row {
      width: 100%;
      justify-content: space-between;
    }
  }
}
</style>

<style lang="less">
.ant-drawer-body {
  max-height: calc(100% - 108px);
  overflow-y: auto;
}
</style>
